interface DropdownOption<T = any> {
    [key: string]: any;
  }
  
  interface DropDownStringOptionAndValueProps<T = any> {
    listInputs: T[];
    label: string;
    inputName: string;
    value: string;
    handleOnChange(e: any): void;
    editableTitle?: JSX.Element;
    valueKey: keyof T;
    displayKey: keyof T;
  }
  
  function DropDownStringOptionAndValue<T>({
    listInputs,
    label,
    value,
    handleOnChange,
    inputName,
    editableTitle,
    valueKey,
    displayKey
  }: DropDownStringOptionAndValueProps<T>) {
    return (
      <div className="form-group">
        {editableTitle ? 
          <label className="control-label">{editableTitle}</label> : 
          <label className="control-label">{label}</label>
        }
        <select
          className="form-control"
          name={inputName}
          value={value}
          onChange={handleOnChange}
        >
          <option value='100'>
            -
          </option>
          {listInputs.map((option) => {
            const optionValue = String(option[valueKey] ?? '');
            const optionDisplay = String(option[displayKey] ?? optionValue ?? '');
            
            return (
              <option key={optionValue} value={optionValue}>
                {optionDisplay}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
  
  export default DropDownStringOptionAndValue;